import React from "react";
import { Trans } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
  PopupTextContent,
} from "../../../components/Common/Popup";
import { useAddToCartUseBuyNow } from "@/react/Webshop/hooks/useAddToCartUseBuyNow";

const AddPackageToCartWarningDialog = ({ handleCancel, handleAddToCart }) => {
  const useBuyNow = useAddToCartUseBuyNow();

  return (
    <Popup
      open={true}
      onClose={handleCancel}
      data-testid="add-to-cart-warning"
    >
      <PopupHeading>
        <Trans>Dear customer</Trans>
      </PopupHeading>

      <PopupContent>
        <PopupTextContent>
          <p>
            <Trans>
              The package will be produced exactly as shown on screen. Don't
              forget that you may choose which picture you would like to use on
              each picture module.
            </Trans>
          </p>
          <p>
            <Trans>
              Would you like to have a look through the package, to make sure
              everything is correct?
            </Trans>
          </p>
        </PopupTextContent>
      </PopupContent>

      <PopupActions>
        <PopupButton
          onClick={handleAddToCart}
          data-testid="add-to-cart-confirm"
        >
          {useBuyNow ? (
            <Trans>Buy now</Trans>
          ) : (
            <Trans>Add package to shopping cart</Trans>
          )}
        </PopupButton>
        <PopupButton onClick={handleCancel}>
          <Trans>Yes, I would like to check</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default AddPackageToCartWarningDialog;
